import { IsOptional, IsString } from "class-validator";

export class FindOneCustomerLeadDto {
  @IsString()
  @IsOptional()
  yzAnonymousId?: string;
}
